import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';
import { LoggedInAuthGuard } from './shared/guards/loggedInAuth.guard';

const routes: Routes = [
  {
    path: 'home',
    loadChildren: () =>
      import('./pages/home/home.module').then((m) => m.HomePageModule),
  },

  {
    path: 'login',
    canActivate: [LoggedInAuthGuard],
    loadChildren: () =>
      import('./pages/sign-in/sign-in.module').then((m) => m.SignInPageModule),
  },

  {
    path: 'contact-us',
    loadChildren: () =>
      import('./pages/contact/contact.module').then((m) => m.ContactPageModule),
  },

  {
    path: 'events',
    loadChildren: () =>
      import('./pages/events/events.module').then((m) => m.EventsPageModule),
  },

  {
    path: 'events-list',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/events-list/events-list.module').then(
        (m) => m.EventsListPageModule
      ),
  },

  {
    path: 'event-create',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/event-create/event-create.module').then(
        (m) => m.EventCreatePageModule
      ),
  },
  {
    path: 'event-update/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/event-update/event-update.module').then(
        (m) => m.EventUpdatePageModule
      ),
  },

  {
    path: 'slider-list',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/slider-list/slider-list.module').then(
        (m) => m.SliderListPageModule
      ),
  },
  {
    path: 'slider-create',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/slider-create/slider-create.module').then(
        (m) => m.SliderCreatePageModule
      ),
  },
  {
    path: 'slider-update/:id',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./pages/slider-update/slider-update.module').then(
        (m) => m.SliderUpdatePageModule
      ),
  },
  {
    path: 'about-us',
    loadChildren: () =>
      import('./pages/about/about.module').then((m) => m.AboutPageModule),
  },
  {
    path: 'book-us',
    loadChildren: () =>
      import('./pages/book-us/book-us.module').then((m) => m.BookUsPageModule),
  },
  { path: '**', redirectTo: 'home' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
